//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.StructureDesign.js";
import "../Features/Features.StructureDesign.FeatureParmsBuilder.js";
import "../no/ScCollector.js";
import "../Features/Features.StructureDesign.ContextAttributeBuilder.js";
import "../no/Expression.js";
import "../Features/Features.StructureDesign.FeatureSpreadsheetBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Features.js";
let d=[[[0,"AddFasteners",1,0],[0,"BeamColumnConnectionSubType",1,0],[1,"BodyOne",0,"ScCollector",0],[1,"BodyTwo",0,"ScCollector",0],[0,"BoltedConnectionName",1,0],[1,"BraceFaces",0,"ScCollector",0],[0,"ConfigurationName",1,0],[0,"ConnectionType",1,0],[1,"ContextAttribute",0,"Features.StructureDesign.ContextAttributeBuilder",0],[0,"DisableRule",1,0],[0,"DrillThrough",1,0],[1,"FaceOne",0,"ScCollector",0],[1,"FaceTwo",0,"ScCollector",0],[0,"GussetPlateConnectionSubType",1,0],[0,"MountingType",1,0],[1,"RotateAngle",0,"Expression",0],[0,"SpliceConnectionSubType",1,0],[1,"StockData",0,"Features.StructureDesign.FeatureSpreadsheetBuilder",0],[1,"XOffset",0,"Expression",0],[1,"YOffset",0,"Expression",0]],[[["sectionModified"],"UpdateStockSectionTypes",{},1,0],[["numGussetConnectionBuilders","gussetConnectionBuilders"],"GetGussetConnectionBuilders",{},0,0],[[],"ExecuteRule",{R_:{executeRuleOk:''}},0,0]],[]];
SPLM.Features.StructureDesign.BoltedConnectionBuilder = class extends SPLM.Features.StructureDesign.FeatureParmsBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.StructureDesign.BoltedConnectionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.StructureDesign.BoltedConnectionBuilder.ConnectionTypes = Object.freeze({
    "Splice" : "Splice", "BeamColumn" : "BeamColumn", "GussetPlate" : "GussetPlate"});

SPLM.Features.StructureDesign.BoltedConnectionBuilder.SpliceConnectionSubTypes = Object.freeze({
    "End" : "End", "Flange" : "Flange", "Web" : "Web"});

SPLM.Features.StructureDesign.BoltedConnectionBuilder.BeamColumnConnectionSubTypes = Object.freeze({
    "End" : "End", "LPlate" : "LPlate", "FlatPlate" : "FlatPlate"});

SPLM.Features.StructureDesign.BoltedConnectionBuilder.GussetPlateConnectionSubTypes = Object.freeze({
    "CornerPlate" : "CornerPlate", "FlatPlate" : "FlatPlate", "LappedPlate" : "LappedPlate"});

SPLM.Features.StructureDesign.BoltedConnectionBuilder.MountingTypes = Object.freeze({
    "Middle" : "Middle", "FlushUp" : "FlushUp", "FlushDown" : "FlushDown"});

export default SPLM;